import React from 'react';
import FirstComparisonControl from 'utils/components/FiltersModal/comparison/FirstComparisonControl';
import {
    BoundaryComparison,
    Comparison,
    ExactComparison,
} from 'utils/components/FiltersModal/comparison/FilterComparison';
import {
    BoundarySign,
    ExactSign,
    getOppositeBoundarySign,
} from 'utils/filter/filter';
import { EnumMap } from '@instinet-analytics/core-lib';
import { ValueType } from '@instinet-analytics/semantic-ui-components';

export interface ComparisonGroupExactProps {
    columnName: string;
    comparison: ExactComparison;
    setComparison?: (comparison: Comparison, commitOnSet?: boolean) => void;
    onInputEnter: () => void;
    enumMap?: EnumMap;
}

export default function ComparisonGroupExact(props: ComparisonGroupExactProps) {
    const { columnName, comparison, setComparison, enumMap, onInputEnter } =
        props;

    if (!comparison || !setComparison) {
        return null;
    }

    function removeDateRangeIfSignIsNotEquals(
        nextComparison: ExactComparison | BoundaryComparison
    ) {
        if (
            (nextComparison.valueType === ValueType.DATE ||
                nextComparison.valueType === ValueType.DATETIME) &&
            Array.isArray(nextComparison.value) &&
            nextComparison.sign !== ExactSign.EQ
        ) {
            nextComparison.value = nextComparison.value[0];
        }
    }

    function onSignBecomeExact(sign: ExactSign) {
        const exactComparison = comparison as ExactComparison;
        const nextComparison = {
            ...exactComparison,
            sign,
        };
        removeDateRangeIfSignIsNotEquals(nextComparison);
        setComparison!(nextComparison);
    }

    function onSignBecomeBoundary(sign: BoundarySign) {
        const exactComparison = comparison as ExactComparison;

        const firstComparison: BoundaryComparison = {
            ...exactComparison,
            sign,
        };

        removeDateRangeIfSignIsNotEquals(firstComparison);

        setComparison!([
            firstComparison,
            {
                valueType: exactComparison.valueType,
                sign: getOppositeBoundarySign(sign),
                value: undefined,
            },
        ]);
    }

    return (
        <FirstComparisonControl
            columnName={columnName}
            comparison={comparison}
            enumMap={enumMap}
            onSignBecomeExact={onSignBecomeExact}
            onSignBecomeBoundary={onSignBecomeBoundary}
            onValueChange={(value) =>
                setComparison({
                    ...comparison,
                    value,
                })
            }
            onInputEnter={onInputEnter}
        />
    );
}
